module.exports = __webpack_public_path__ + "img/img_29@2x.d8c18101.png";